export default class Product {
  constructor(data) {
    this.id = data.id;
    this.codeSupplier = data.codeSupplier;
    this.name = data.name;
    this.packaging = data.packaging;
    this.supplierId = data.supplierId;
    this.uc = data.uc;
    this.price = data.price;
    this.unit = data.unit;
  }
}
